import React from 'react';
import {Table} from 'semantic-ui-react';
import {NoData} from "../../components/table/no-data";

export default class SiteTableContactRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
}
  render() {
      return (
          <Table.Row>
            <Table.Cell>{this.props.data.contactName || <NoData/>}</Table.Cell>
            <Table.Cell>{this.props.data.jobTitle || <NoData/>}</Table.Cell>
            <Table.Cell>{this.props.data.telephone || <NoData/>}</Table.Cell>
            <Table.Cell>{this.props.data.email || <NoData/>}</Table.Cell>
          </Table.Row>
        );
  }
}